import {signOut} from "firebase/auth";
import {getFirebase} from "../config/firebase.config";

const {auth} = getFirebase();

export const logoutUser = async (event) => {
    try {
        await signOut(auth)
    } catch (e) {
        console.log(e)
    }
}

export const getAuthToken = async () => await auth.currentUser.getIdToken();
